import { render, staticRenderFns } from "./ssp-viewer-details.vue?vue&type=template&id=028f10aa&scoped=true"
import script from "./ssp-viewer-details.vue?vue&type=script&lang=js"
export * from "./ssp-viewer-details.vue?vue&type=script&lang=js"
import style0 from "./ssp-viewer-details.vue?vue&type=style&index=0&id=028f10aa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028f10aa",
  null
  
)

export default component.exports